/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './campaign-view.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../templates-front/template-front-dashboard/template-front-dashboard.component.ngfactory';
import * as i3 from '../../../../../app/front/templates-front/template-front-dashboard/template-front-dashboard.component';
import * as i4 from '../../../../../app/front/front.service';
import * as i5 from '../../../../../app/services/client.service';
import * as i6 from '../../../../../app/services/master.service';
import * as i7 from '../../../../../app/services/template.service';
import * as i8 from '../../../../../app/services/subgroup.service';
import * as i9 from '@angular/router';
import * as i10 from '../../../../../app/services/vault.service';
import * as i11 from '../../../../../app/services/campaign.service';
import * as i12 from '../../../../../app/services/global.service';
import * as i13 from '../../../../../app/services/domain.service';
import * as i14 from '../../../../../app/services/mydesktop.service';
import * as i15 from '../../../../../app/front/front-campaigns/campaign-view/campaign-view.component';
import * as i16 from '../../../../../app/services/auth.service';
const styles_CampaignViewComponent:any[] = [i0.styles];
export const RenderType_CampaignViewComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CampaignViewComponent,data:{}});
export function View_CampaignViewComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-template-front-dashboard',
      [['page','campaign']],(null as any),(null as any),(null as any),i2.View_TemplateFrontDashboardComponent_0,
      i2.RenderType_TemplateFrontDashboardComponent)),i1.ɵdid(1,5488640,(null as any),
      0,i3.TemplateFrontDashboardComponent,[i4.FrontService,i5.ClientService,i6.MasterService,
          i7.TemplateService,i8.SubgroupService,i9.Router,i10.VaultService,i11.CampaignService,
          i12.GlobalService,i1.ChangeDetectorRef,i13.DomainService,i14.MyDesktopService],
      {page:[0,'page']},(null as any))],(_ck,_v) => {
    const currVal_0:any = 'campaign';
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_CampaignViewComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-campaign-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_CampaignViewComponent_0,
      RenderType_CampaignViewComponent)),i1.ɵdid(1,114688,(null as any),0,i15.CampaignViewComponent,
      [i16.AuthService,i9.ActivatedRoute,i11.CampaignService,i13.DomainService,i14.MyDesktopService,
          i10.VaultService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CampaignViewComponentNgFactory:i1.ComponentFactory<i15.CampaignViewComponent> = i1.ɵccf('app-campaign-view',
    i15.CampaignViewComponent,View_CampaignViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jYW1wYWlnbnMvY2FtcGFpZ24tdmlldy9jYW1wYWlnbi12aWV3LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvZnJvbnQvZnJvbnQtY2FtcGFpZ25zL2NhbXBhaWduLXZpZXcvY2FtcGFpZ24tdmlldy5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2h0bWwvTXlEZXNpZ25WMy9odG1sL3NyYy9hcHAvZnJvbnQvZnJvbnQtY2FtcGFpZ25zL2NhbXBhaWduLXZpZXcvY2FtcGFpZ24tdmlldy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC9mcm9udC1jYW1wYWlnbnMvY2FtcGFpZ24tdmlldy9jYW1wYWlnbi12aWV3LmNvbXBvbmVudC50cy5DYW1wYWlnblZpZXdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLXRlbXBsYXRlLWZyb250LWRhc2hib2FyZCBwYWdlPVwiY2FtcGFpZ25cIj48L2FwcC10ZW1wbGF0ZS1mcm9udC1kYXNoYm9hcmQ+IiwiPGFwcC1jYW1wYWlnbi12aWV3PjwvYXBwLWNhbXBhaWduLXZpZXc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTttREFBQSxVQUFBO01BQUE7O3VGQUFBO01BQUE7SUFBOEI7SUFBOUIsV0FBOEIsU0FBOUI7Ozs7b0JDQUE7TUFBQTtzQ0FBQSxVQUFBO01BQUE7MEJBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/front-campaigns/campaign-view/campaign-view.component.ngfactory.ts